import React, { FC, useEffect, useState } from 'react';
import { type TableColumnsType } from 'antd';
import { image } from '../../../../app/utils/common/image';
import TableComponent from '../../../atoms/TableComponent/Tablecomponent';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../app/utils/hooks/reduxHook';
import { getAllGroups } from '../../../../redux/API/GroupApi';
import { getImageURL } from '../../../../app/utils/common/getImageUrl';
import { PaginationType } from '../../../../dto/Pagination.dto';
import "./SelectModal.scss";
import { ProjectGroupType } from '../../../../dto/Projects.dto';
import Checkbox from '../../../atoms/Checkbox/Checkbox';
import { setGroupPagination } from '../../../../redux/Slices/groupSlice';
import { SiteSupervisorType } from '../../../../dto/SiteSupervisor.dto';
import { setSiteSupervisorPagination, setUsersManagementPagination } from '../../../../redux/Slices/allUsersSlice';
import { getAllUserManagementAPI } from '../../../../redux/API/AllUsersAPI';
import { UserManagementType } from '../../../../dto/User.dto';

const AddSiteSupervisorTable: FC<{
    selectedSupervisors: UserManagementType[],
    onChangeData: (key: string, value: SiteSupervisorType[]) => void;
    setIsSelectSiteSupervisorModalOpen: (data: boolean) => void;
}> = ({
    selectedSupervisors,
    onChangeData,
    setIsSelectSiteSupervisorModalOpen,
}) => {
        const navigate = useNavigate()
        const [loading, setLoading] = useState<boolean>(false);
        const { groups, groupPagination } = useAppSelector(state => state.group);
        const { UserManagement, userManagementPagination, pagination } = useAppSelector(state => state.allUsers)
        // const [newSelectedGroups, setNewSelectedGroups] = useState<any[]>(selectedGroups);
        const [newSelectedSupervisors, setNewSelectedSupervisors] = useState<any[]>(selectedSupervisors);

        const [pageAdded, setPageAdded] = useState<number[]>([]);
        const dispatch = useAppDispatch();
        const [isSelectAll, setIsSelectAll] = useState(false);
        const [selectedCps, setSelectedCps] = useState<number[]>([]);

       useEffect(() => {
            if (!loading) {
                setLoading(true);
                dispatch(getAllUserManagementAPI({ filterBy: "active", role_id: 4, page: userManagementPagination?.current_page, total_page: 5 })).unwrap()
                    .then((data: {
                        user_data: any,
                        pagination: PaginationType
                    }) => {

                    }).catch(() => { }).finally(() => {
                        setLoading(false);
                    })
            }
        }, [userManagementPagination?.current_page]);

        useEffect(() => {
            return () => {
                dispatch(setUsersManagementPagination({ ...userManagementPagination, current_page: 1 }));
            }
        }, [])
        const isAllSelected = UserManagement?.every((user: any) =>
            newSelectedSupervisors?.some(selected => selected.user_id === user.user_id)
        );
    
        const handleSupervisorSelection = (selectedSupervisor: UserManagementType) => {
            const exists = newSelectedSupervisors.some(
                (supervisor) => supervisor.site_supervisor_id === selectedSupervisor.user_id
            );
        
            if (exists) {
                setNewSelectedSupervisors((prev) =>
                    prev.filter(
                        (supervisor) => supervisor.site_supervisor_id !== selectedSupervisor.user_id
                    )
                );
            } else {
                setNewSelectedSupervisors((prev) => [
                    ...prev,
                    { site_supervisor_id: selectedSupervisor.user_id, ...selectedSupervisor },
                ]);
            }
        };
        
    
        const handleSelectAllGroups = () => {
            if (isAllSelected) {
                // Deselect all groups on the current page
                setNewSelectedSupervisors(
                    newSelectedSupervisors.filter(
                        selected => !groups.some(group => group.group_id === selected.group_id)
                    )
                );
            } else {
                // Select all groups on the current page
                const updatedSelection = [
                    ...newSelectedSupervisors,
                    ...UserManagement.filter(
                        user => !newSelectedSupervisors.some(selected => selected.user_id === user.user_id)
                    )
                ];
                setNewSelectedSupervisors(updatedSelection);
            }
        };

        const handleAllocate = () => {
            if (newSelectedSupervisors.length > 0) {
                onChangeData("select-supervisors", newSelectedSupervisors);
                setIsSelectSiteSupervisorModalOpen(false)
            } else {

            }
        }
        const columns: TableColumnsType<UserManagementType> = [
            {
                title: 'Photo',
                dataIndex: 'Photo',
                render: (text, record) => {
                    return (
                        <img
                            src={record.profile_image ? getImageURL(record.profile_image) : image.DEFAULT_PROFILE_IMAGE}
                            alt="Profile"
                            className='reg-profile'
                        />
                    )
                },
            },
            {
                title: 'Name',
                dataIndex: 'name',
                render: (text, record) => (
                    <div >
                        {record.name}
                    </div>
                )
            },
            {
                title: 'Number',
                dataIndex: 'number',
                render: (text, record) => (
                    <div >
                        {record.phone_number}
                    </div>
                )
            },
            {
                title: 'Action',
                dataIndex: 'action',
                render: (text, record) => (
                    <div>
                        <Checkbox
                        checked={newSelectedSupervisors.some(
                            (supervisor) => supervisor.site_supervisor_id === record.user_id
                        )}
                        onChange={() => handleSupervisorSelection(record)}
                    />
                    </div>
                ),
            },
        ];

        const handlePageChange = (pageNumber: number) => {
            if (!loading) {
                let tempData = { ...userManagementPagination };
                tempData.current_page = pageNumber
                dispatch(setUsersManagementPagination(tempData));
            }
        };
        return (
            <div className='select_group_table'>
                <div>
                    <h2 style={{ textAlign: "center" }}>Select Site Supervisor</h2>
                </div>
                {/* {siteSuperVisors.length > 0 &&
                    <div className='select-all-button-container'>
                        <p>Select All</p>
                        <Checkbox
                        checked={isAllSelected}
                        onChange={handleSelectAllGroups}
                        />

                    </div>
                } */}
                <div style={{ minHeight: "300px" }}>
                    <TableComponent columns={columns}
                        dataSource={UserManagement}
                        loading={loading}
                        pageNumbers={Array.from({ length: userManagementPagination?.total_pages }, (_, index) => index + 1)}
                        handlePageLink={handlePageChange}
                        isPagination={userManagementPagination?.total_pages > 1}
                        totalProfile={userManagementPagination?.total_data}
                        prevPage={() => handlePageChange(userManagementPagination?.current_page - 1)}
                        nextPage={() => handlePageChange(userManagementPagination?.current_page)}
                        activePage={userManagementPagination?.current_page}
                        currentTotal={Math.min(userManagementPagination?.current_page * userManagementPagination?.page_size, UserManagement?.length)} />

                </div>

                <div className='center_div create_project_btn_container' style={{ marginBottom: "10px" }}>
                    {/* <button className='cancel_btn' onClick={() => {}}>
                    Cancel
                </button> */}
                    <button className='submit_btn' onClick={() => { handleAllocate() }}>
                        Allocate
                    </button>
                </div>
            </div>

        );
    };

export default AddSiteSupervisorTable;